import React from 'react';
import { Snackbar, Alert as MuiAlert } from '@mui/material';

const Alert: React.FC<any> = (props) => <MuiAlert elevation={6} variant="filled" {...props} />;

export interface SnackBarProps {
  open: boolean;
  autoHideDuration?: number;
  close: () => void;
  text: string;
  success: boolean;
}

const SnackbarComponent: React.FC<SnackBarProps> = ({ open, autoHideDuration, text, success, close }) => (
  <Snackbar 
  open={open} 
  autoHideDuration={autoHideDuration} 
  onClose={close}
  anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
  // sx={{ top: '50%', transform: 'translateY(-50%)' }}
  >
    <div>
      <Alert severity={success ? 'success' : 'error'}>{text}</Alert>
    </div>
  </Snackbar>
);

export default SnackbarComponent;
